import { FormikErrors, FormikTouched, FormikValues, getIn } from 'formik'
import FormLabel from '@material-ui/core/FormLabel'
import React from 'react'
import { useStyles } from '../pages/styled'
import theme from '../theme'

const LabelMessage = ({
  name,
  errors,
  touched,
  text,
  required = true,
}: {
  name: string
  errors: FormikErrors<FormikValues>
  touched: FormikTouched<FormikValues>
  text: string
  required?: boolean
}) => {
  const classes = useStyles(theme)
  return (
    <FormLabel
      className={classes.labelArray}
      required={required}
      error={getIn(errors, name) && getIn(touched, name)}
    >
      {text}
    </FormLabel>
  )
}

export default LabelMessage
